import script from "./ShareDocumentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareDocumentModal.vue?vue&type=script&setup=true&lang=js"

import "./ShareDocumentModal.vue?vue&type=style&index=0&id=3bec4a8e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bec4a8e"]])

export default __exports__